import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["signatureArea"]

  toggle(event) {
    if (event.target.checked) {
      this.signatureAreaTarget.classList.remove("opacity-50", "pointer-events-none")
    } else {
      this.signatureAreaTarget.classList.add("opacity-50", "pointer-events-none")
    }
  }
}
